import { IMAGE_ORIENTATION_CACHE } from './variables';
import { ORIENTATION } from '../hooks/useImageOrientation';

// Poses to feature in the GalleryIntro splash (the images-on-black promo page): VERTICAL
// images only — no landscape class photos / renders — drawn from the pricelist's CONFIGURED
// pose choices (packagePoses) when it has them, so the intro mirrors what the customer can
// actually pick. Shared by the senior and elementary builders so both filter identically.

// Landscape check keyed off MEASURED orientation (the same shared cache AbsolutePosImgs
// populates via useImageOrientations), falling back to the filename heuristic only until
// the image has been measured. The pure-filename heuristic alone missed the .png class
// photo (-25.png) and landscape frames 10-13, letting them squeeze into the vertical cards.
const isLandscape = (url) => {
  if (!url) return false;
  const measured = IMAGE_ORIENTATION_CACHE[url]?.orientation;
  if (measured) return measured === ORIENTATION.LANDSCAPE;
  return url.includes('.jpg') || url.includes('-23.png');
};

export default function introPoses(poses, packagePoses) {
  const configured = packagePoses || [];
  return (poses || []).filter((pose) => {
    const fg = pose.imageUrl || pose.watermarkUrl;
    if (!fg || isLandscape(fg)) return false; // vertical only
    // Restrict to the pricelist's pose choices when it configures any; otherwise show
    // every vertical pose (a pricelist with no explicit pose list = all of them).
    if (configured.length === 0) return true;
    return configured.some((pp) => pp.poseNumber === pose.number);
  });
}
